import React    from 'react';


class What extends React.Component{

    state = {
        selectedItem: null,
        showResults: null,
        success: false,
        failure: false
    }


    showResults =()=>{

            if(this.state.selectedItem === this.props.task.ID){
                
                this.setState({
                    showResults: true,
                    success: true
                });

                this.props.updatePoints(this.props.points_max);

            }else{

                this.setState({
                    showResults: true,
                    failure: true
                });

                this.props.updatePoints(0);
            }

        this.props.pointOfNoReturn();
    }


    onSelect =(ID)=>{

        this.setState({
            selectedItem: ID
        });

        this.props.addButton(<button id="btnMain" onClick={this.showResults}><i className="material-icons">check</i></button>);

    }


    createList =(list)=>{

        return(
            <div className="list-group">
                {list.map((item) => {

                    return(
                        <div
                        key={item.ID.toString()}
                        className={"list-group-item " + (item.ID === this.state.selectedItem ? 'item-selected' : '')}
                        onClick={()=> this.onSelect(item.ID)}
                        >
                            <figure>
                                <img src={item.image_extras.vr_game_image_extras_picture.sizes.thumbnail} alt={item.image_extras.vr_game_image_extras_title} />
                                <h4>{item.image_extras.vr_game_image_extras_title}</h4>
                            </figure>
                        </div>
                    )
                })}
            </div>
        )
    }


    render(){

        let content = '';
               
            if(this.state.showResults){

            if(this.state.failure) content = <div id="taskResults" className="task-fail"><div className="page-content-header"><i className="material-icons g-icon-huge">block</i></div><h1>A Fail!</h1><p>No points for you!<br/>Better luck next time.</p></div>
            else content = <div id="taskResults" className="task-success"><div className="page-content-header"><i className="material-icons g-icon-huge">check</i></div><h1>A Success!</h1><p>You earned {this.props.points_max} points. Groovy.<br/>Let's move on!</p></div>
            }else{
                content = <div>{this.createList(this.props.mission.vr_images)}</div>
            }

        return(
            <section id="taskContainer" className={"page-content " + this.props.classes}>
                <h2>What is it?</h2>
                {content}
                <div className={(this.state.selectedItem && !this.state.showResults ? 'ui-guide-message' : 'g-hide')}><span>Are you sure?</span></div>
            </section>
        )
    }
}


export default What;